export default __webpack_public_path__ + "static/media/h5-bg4.4d48fc13.png";